// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Leader_left_section__dTjSY {
  max-height: 100%;
  margin: 3.5rem 0;
  display: flex;
  gap: 1rem;
  justify-content: flex-start;
  flex-direction: column;

  & h6 {
    color: #242020;
    font-family: Inter;
    font-size: 2rem;
    font-weight: 700;
  }

  & span {
    color: #62677a;
    font-family: Inter;
    font-size: 0.87rem;
    font-weight: 400;
  }

  & p {
    margin: 0;
    color: #242020;
    font-family: Inter;
    font-size: 0.9rem;
    font-weight: 500;
  }

  & img {
    max-width: 100%;
    height: auto;
    margin-top: 0.5rem;
  }
}

.Leader_right_section__6ZHwk {
  margin: 4rem 0;

  & img {
    width: 100%;
    height: auto;
  }

  .Leader_clientSection__kQvJy {
    position: relative;
    margin-top: 1rem;
    width: 100%;
    padding: 1rem;
    height: auto;
    background-color: var(--primary-color);

    & p {
      padding-left: 1.2rem;
      width: 83%;
      color: var(--text-color);
      font-family: Inter;
      font-size: 0.9rem;
      font-weight: 400;
    }

    & img {
      position: absolute;
      width: 30px;
      height: auto;
      top: -12px;
      left: 10px;
    }
  }
}
/* ------------media-queries---------- */

@media screen and (max-width: 568px) {
  .Leader_left_section__dTjSY {
    margin: 2rem 0 0;
  }

  .Leader_clientSection__kQvJy {
    max-width: 100%;
    margin: 2rem 0 0;
  }
  .Leader_right_section__6ZHwk img {
    width: 100%;
  }

  .Leader_right_section__6ZHwk {
    margin: 1rem 0;
  }

  .Leader_right_section__6ZHwk .Leader_clientSection__kQvJy {
    width: 100%;
  }

  .Leader_right_section__6ZHwk .Leader_clientSection__kQvJy p {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Leaders/Leader.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,sBAAsB;;EAEtB;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE,cAAc;;EAEd;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,YAAY;IACZ,sCAAsC;;IAEtC;MACE,oBAAoB;MACpB,UAAU;MACV,wBAAwB;MACxB,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;MACE,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,UAAU;MACV,UAAU;IACZ;EACF;AACF;AACA,wCAAwC;;AAExC;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".left_section {\n  max-height: 100%;\n  margin: 3.5rem 0;\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-start;\n  flex-direction: column;\n\n  & h6 {\n    color: #242020;\n    font-family: Inter;\n    font-size: 2rem;\n    font-weight: 700;\n  }\n\n  & span {\n    color: #62677a;\n    font-family: Inter;\n    font-size: 0.87rem;\n    font-weight: 400;\n  }\n\n  & p {\n    margin: 0;\n    color: #242020;\n    font-family: Inter;\n    font-size: 0.9rem;\n    font-weight: 500;\n  }\n\n  & img {\n    max-width: 100%;\n    height: auto;\n    margin-top: 0.5rem;\n  }\n}\n\n.right_section {\n  margin: 4rem 0;\n\n  & img {\n    width: 100%;\n    height: auto;\n  }\n\n  .clientSection {\n    position: relative;\n    margin-top: 1rem;\n    width: 100%;\n    padding: 1rem;\n    height: auto;\n    background-color: var(--primary-color);\n\n    & p {\n      padding-left: 1.2rem;\n      width: 83%;\n      color: var(--text-color);\n      font-family: Inter;\n      font-size: 0.9rem;\n      font-weight: 400;\n    }\n\n    & img {\n      position: absolute;\n      width: 30px;\n      height: auto;\n      top: -12px;\n      left: 10px;\n    }\n  }\n}\n/* ------------media-queries---------- */\n\n@media screen and (max-width: 568px) {\n  .left_section {\n    margin: 2rem 0 0;\n  }\n\n  .clientSection {\n    max-width: 100%;\n    margin: 2rem 0 0;\n  }\n  .right_section img {\n    width: 100%;\n  }\n\n  .right_section {\n    margin: 1rem 0;\n  }\n\n  .right_section .clientSection {\n    width: 100%;\n  }\n\n  .right_section .clientSection p {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"left_section": `Leader_left_section__dTjSY`,
	"right_section": `Leader_right_section__6ZHwk`,
	"clientSection": `Leader_clientSection__kQvJy`
};
export default ___CSS_LOADER_EXPORT___;
